import { listWorkerRequirements } from 'api/admin/credentials/listWorkerRequirements'

const credentialsKey = ['credentials'] as const

export const credentialsKeys = {
  all: credentialsKey,
  workerRequirements: () => [...credentialsKey, 'workerRequirements'] as const,
  workerRequirementsList: (
    params?: Parameters<typeof listWorkerRequirements>[0]
  ) => [...credentialsKeys.workerRequirements(), params] as const,
}
